module.exports = __webpack_public_path__ + "img/Training_courses_img_6.600174b0.jpg";